export default class Replace {
  constructor() {
    // document.body.innerHTML = document.body.replace("&quot;", "n");
  }
}
